import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import textStyles from './description-style'

const Description = props => {
  const classes = textStyles(props.theme)
  const appliedClasses = classNames(
    classes.description, {
    [classes.lastChildWithTitle]: props.classType === 'lastChildWithTitle',
    [classes.separatingWithTitle]: props.classType === 'separatingWithTitle',
  })

  return (
    <p className={appliedClasses}>{props.children}</p>
  )
}

Description.propTypes = {
  children: PropTypes.node.isRequired,
  classType: PropTypes.string,
}

export default withTheme(Description)
